(() => {
  const guide = document.querySelector('.ts-learning-guide-shell');
  const control = guide?.querySelector('[data-ts-scroll-control]');
  const content = guide?.querySelector('.ts-learning-guide__content');

  if (!guide || !control || !content) return;

  const icon = control.querySelector('span');
  const update = () => {
    const goingUp = window.scrollY > Math.max(420, content.offsetTop * 0.7);
    control.dataset.direction = goingUp ? 'up' : 'down';
    control.setAttribute('aria-label', goingUp ? 'Back to the top of this guide' : 'Scroll down to the guide content');
    if (icon) icon.textContent = goingUp ? '↑' : '↓';
  };

  control.addEventListener('click', () => {
    const destination = control.dataset.direction === 'up' ? guide : content;
    destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
